/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReleaseManualChangesResponseFields } from './ReleaseManualChangesResponseFields';
import {
    ReleaseManualChangesResponseFieldsFromJSON,
    ReleaseManualChangesResponseFieldsFromJSONTyped,
    ReleaseManualChangesResponseFieldsToJSON,
} from './ReleaseManualChangesResponseFields';

/**
 * 
 * @export
 * @interface ReleaseManualChangesResponse
 */
export interface ReleaseManualChangesResponse {
    /**
     * 
     * @type {string}
     * @memberof ReleaseManualChangesResponse
     */
    releaseId: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseManualChangesResponse
     */
    documentId?: string | null;
    /**
     * 
     * @type {ReleaseManualChangesResponseFields}
     * @memberof ReleaseManualChangesResponse
     */
    fields: ReleaseManualChangesResponseFields;
}

/**
 * Check if a given object implements the ReleaseManualChangesResponse interface.
 */
export function instanceOfReleaseManualChangesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "releaseId" in value;
    isInstance = isInstance && "fields" in value;

    return isInstance;
}

export function ReleaseManualChangesResponseFromJSON(json: any): ReleaseManualChangesResponse {
    return ReleaseManualChangesResponseFromJSONTyped(json, false);
}

export function ReleaseManualChangesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReleaseManualChangesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseId': json['release_id'],
        'documentId': !exists(json, 'document_id') ? undefined : json['document_id'],
        'fields': ReleaseManualChangesResponseFieldsFromJSON(json['fields']),
    };
}

export function ReleaseManualChangesResponseToJSON(value?: ReleaseManualChangesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_id': value.releaseId,
        'document_id': value.documentId,
        'fields': ReleaseManualChangesResponseFieldsToJSON(value.fields),
    };
}

